import { useMediaQuery } from "@mantine/hooks";

export const useIsDesktop = (): boolean => {
  return useMediaQuery("(min-width: 1200px)");
};
